/*
  Einheitlicher Tooltip für Shiftplan-V2-Komponenten.

  Optik = DS-Tooltip (--ds-tooltip-*). Eigenständig bleiben nur die
  Anforderungen des Rasters: kürzere Delays beim Überfahren vieler Zellen,
  ein Popper mit fixed-Strategie/Flip innerhalb des scrollbaren Rasters,
  mehrzeilige Titel (pre-line) und ein z-index über den Floating-Panels.
*/

import React from "react";
import { Tooltip } from "@mui/material";
import { tooltipClasses } from "@mui/material/Tooltip";

const TOOLTIP_Z_INDEX = 2610;

export default function ShiftplanTooltip({
  title,
  children,
  placement = "top",
  arrow = true,
  enterDelay = 180,
  enterNextDelay = 100,
  leaveDelay = 70,
  disableInteractive = true,
  forceClosed = false,
  ...props
}) {
  const shouldRenderTooltip = Boolean(title) || forceClosed;
  if (!shouldRenderTooltip) return children;

  return (
    <Tooltip
      {...(forceClosed ? { open: false } : {})}
      title={forceClosed ? "" : title}
      placement={placement}
      arrow={arrow}
      enterDelay={enterDelay}
      enterNextDelay={enterNextDelay}
      leaveDelay={leaveDelay}
      disableInteractive={disableInteractive}
      disableHoverListener={forceClosed}
      disableFocusListener={forceClosed}
      disableTouchListener={forceClosed}
      slotProps={{
        popper: {
          sx: {
            zIndex: TOOLTIP_Z_INDEX,
          },
          popperOptions: {
            strategy: "fixed",
          },
          modifiers: [
            {
              name: "offset",
              options: {
                offset: [0, 8],
              },
            },
            {
              name: "preventOverflow",
              options: {
                boundary: "viewport",
                padding: 8,
              },
            },
            {
              name: "flip",
              options: {
                padding: 8,
              },
            },
          ],
        },
        tooltip: {
          sx: {
            maxWidth: "var(--ds-tooltip-max-width)",
            paddingInline: "var(--ds-tooltip-pad-inline)",
            paddingBlock: "var(--ds-tooltip-pad-block)",
            borderRadius: "var(--ds-tooltip-radius)",
            backgroundColor: "var(--ds-tooltip-bg)",
            color: "var(--ds-tooltip-text)",
            boxShadow: "var(--ds-tooltip-shadow)",
            fontFamily: "var(--ds-font-family)",
            fontSize: "var(--ds-tooltip-font-size)",
            lineHeight: "var(--ds-tooltip-line-height)",
            fontWeight: "var(--ds-tooltip-font-weight)",
            whiteSpace: "pre-line",
            [`&.${tooltipClasses.tooltipPlacementTop}`]: {
              marginBottom: "0px",
            },
            [`&.${tooltipClasses.tooltipPlacementBottom}`]: {
              marginTop: "0px",
            },
            [`&.${tooltipClasses.tooltipPlacementLeft}`]: {
              marginRight: "0px",
            },
            [`&.${tooltipClasses.tooltipPlacementRight}`]: {
              marginLeft: "0px",
            },
          },
        },
        arrow: {
          sx: {
            color: "var(--ds-tooltip-bg)",
            "&::before": {
              boxShadow: "var(--ds-tooltip-shadow)",
            },
          },
        },
      }}
      {...props}
    >
      {children}
    </Tooltip>
  );
}
